/**
 * Internal dependencies
 */
import initFancybox from './init-fancybox';
import handleMegaMenu from './mega-menu';
import { throttle, scrollDetector } from './scroll-detector';

export {
	initFancybox,
	handleMegaMenu as initMegaMenu,
	scrollDetector as initScrollDetector,
	throttle,
};
